import { connect } from 'react-redux';
import { formValueSelector, submit } from 'redux-form';
import { withRouter } from 'hocs/router';
import actions from '../../../actions/satisfaction';
import ChatCustomization from '../../../components/sections/satisfaction/components/ChatCSAT/ChatCustomization';
import { CustomizationPageSelectors } from '../../../components/sections/satisfaction/components/common/selectors';
const { satisfactionLoadChatGlobalSettingsRequest, satisfactionLoadChatLanguageLevelSettingsRequest, satisfactionSaveChatLanguageLevelSettingsRequest, } = actions;
const FORM_NAME = 'satisfactionChatCustomization';
const selector = formValueSelector(FORM_NAME);
const mapStateToProps = (state, ownProps) => {
    const { params: { language }, } = ownProps;
    const { values, asyncStatus } = state.settings.satisfaction.customization.widgetchat.languagesLevel;
    let isSetup = null;
    let id = null;
    if (asyncStatus === 'succeeded') {
        const translation = values === null || values === void 0 ? void 0 : values.find((t) => t.language === language);
        id = (translation === null || translation === void 0 ? void 0 : translation.id) || null;
        isSetup = translation === undefined;
    }
    const initialValues = {
        customization: CustomizationPageSelectors.initialChatValuesSelector(state, {
            settingsId: id,
        }),
    };
    return {
        ratingQuestionPreview: selector(state, 'customization.rating_question'),
        ratingStylePreview: selector(state, 'customization.look_and_feel'),
        followUpQuestionPreview: selector(state, 'customization.rating_follow_up_question'),
        placeholderTextPreview: selector(state, 'customization.rating_placeholder_text'),
        thankYouMessagePreview: selector(state, 'customization.rating_completed_message'),
        id,
        isSetup,
        language,
        initialValues,
        asyncStatus,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    const { params: { language }, } = ownProps;
    return {
        loadGlobalSettings: () => dispatch(satisfactionLoadChatGlobalSettingsRequest('widgetchat')),
        loadLanguageSettings: () => dispatch(satisfactionLoadChatLanguageLevelSettingsRequest('widgetchat')),
        dispatchOnSubmit: (id) => (fields) => {
            dispatch(satisfactionSaveChatLanguageLevelSettingsRequest(Object.assign(Object.assign({}, fields), { language, channel: 'widgetchat', id, level: 'language' })));
        },
        onChange: ({ enabled }) => {
            // This is unfortunately the only way we can trigger a submission when
            // the `enabled` hidden field has been added. It is not possible
            // to call `change()` and `submit()` sequentially.
            if (enabled !== undefined) {
                dispatch(submit(FORM_NAME));
            }
        },
    };
};
const mergeProps = (stateProps, dispatchProps, ownProps) => {
    return Object.assign(Object.assign(Object.assign(Object.assign({}, ownProps), stateProps), dispatchProps), { onSubmit: dispatchProps.dispatchOnSubmit(stateProps.id) });
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(ChatCustomization));
